import logoFlow from '@/assets/al_flow_login.svg';
import logoAfferolab from '@/assets/logo_afferolab_dark_bg.svg';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React, { ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

const Footer: React.FC = () => {
    const {
        strings,
        appOrg: { isWhiteLabel, isTotvs, organization },
    } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        appOrg: state.appOrganization.data,
    }));

    const year: number = new Date().getFullYear();

    const footer: ReactNode = useMemo(() => {
        if (isWhiteLabel) {
            return <span>{organization.name}</span>;
        }

        if (isTotvs) {
            return <span>{Constants.APP_TOTVS_TITLE}</span>;
        }

        return <img alt="" className="logoFlow" src={logoFlow} />;
    }, [isWhiteLabel, isTotvs, organization.name, logoFlow]);

    return (
        <footer className="footer">
            <p className="text-left m--none m-left--md p-v--xs float-left">
                {!isWhiteLabel && !isTotvs && (
                    <>
                        <span>{strings.A_PRODUCTION}</span>
                        <img alt="" className="logoAfferolab" src={logoAfferolab} />
                        <span>| Ⓒ {year}</span>
                    </>
                )}
            </p>

            <div className="containerLogoFlow text-center">{footer}</div>
        </footer>
    );
};

export default Footer;
